// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1MJVj","inputWrap":"CustomTip_inputWrap__3hzRp"};